export default __webpack_public_path__ + "static/media/first-reward.8a417e7e.png";